export default {
    INVOICE: '/invoices/:invoiceId',
    HOME: '/',
    LOGIN: '/login',
};
